import React from "react";
import useLanguage from "../../hooks/language";

export default function HpvRecommendationsPanel(): React.ReactElement {
    const { translations } = useLanguage();
    const t = translations.recommendationsSection.hpv.bookedAppointment;

    return (
        <div style={{ textAlign: "left" }}>
            <p>
                <strong>{t.positive.highlight}</strong> {t.positive.description}
            </p>
            <p>
                <strong>{t.negative.highlight}</strong> {t.negative.description}
            </p>
            <p>
                <strong>{t.inconclusive.highlight}</strong>{" "}
                {t.inconclusive.description}
            </p>
            <p>{t.symptoms}</p>
        </div>
    );
}
